import { rebind, merge } from "../utils";
import { tradeVolumeIndex } from "../calculator";
import baseIndicator from "./baseIndicator";

const ALGORITHM_TYPE = "TradeVolumeIndex";

export default function () {
  const base = baseIndicator()
    .type(ALGORITHM_TYPE)
    .accessor((d) => d.tradeVolumeIndex);

  const underlyingAlgorithm = tradeVolumeIndex();

  const mergedAlgorithm = merge()
    .algorithm(underlyingAlgorithm)
    .merge((datum, indicator) => {
      datum.tradeVolumeIndex = indicator;
      return datum;
    });

  const indicator = function (data, options = { merge: true }) {
    if (options.merge) {
      if (!base.accessor())
        throw new Error(
          `Set an accessor to ${ALGORITHM_TYPE} before calculating`,
        );
      return mergedAlgorithm(data);
    }
    return underlyingAlgorithm(data);
  };

  rebind(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
  rebind(indicator, underlyingAlgorithm, "options", "undefinedLength");
  rebind(indicator, mergedAlgorithm, "merge", "skipUndefined");

  return indicator;
}
